import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const importShipmentApi = createApi({
    reducerPath: "importShipmentApi",
    baseQuery,
    prepareHeaders: (headers) => {
        const token = localStorage.getItem("userToken");
        if (token) headers.set("Authorization", `Bearer ${token}`);
        headers.set("X-Request-Id", crypto.randomUUID());
        return headers;
    },
    tagTypes: ["importshipment"],
    endpoints: (builder) => ({
        getShipmentById: builder.query({
            query: ({ id }) => `import/shipment/${id}`,
            transformResponse: (response) => {
                const data = response?.data ?? [];
                const normalized = Array.isArray(data) ? data : [data];
                return normalized.map((item, index) => ({
                    ...item,
                    SrNo: index + 1,
                    id: item.importShipmentId, // 👈 use backend's exportEntityId
                }));
            },
            providesTags: ["importshipment"],
        }),
        updateShipment: builder.mutation({
            query: ({ id, subId, ...data }) => ({
                url: `import/shipment/${id}/${subId}`,
                method: "PUT",
                headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
                body: { shipment: data },
            }),
            invalidatesTags: ["importshipment"],
        }),
        createShipment: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `import/shipment/${id}`,
                method: "PUT",
                headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
                body: { shipment: data },
            }),
            invalidatesTags: ["importshipment"],
        }),
        deleteShipment: builder.mutation({
            query: ({ id}) => ({
              url: `import/shipment/${id}`,
              method: "DELETE",
              headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
            }),
            invalidatesTags: ["importshipment"],
          }),









    }),






});


export const {
    useCreateShipmentMutation,
    useLazyGetShipmentByIdQuery,
    useUpdateShipmentMutation,
    useDeleteShipmentMutation



} = importShipmentApi;
